angular.module('FlexyBeautyApp.services').factory('LoaderKyc', ["KycDocumentSrv",
    function (KycDocumentSrv) {

        let LoaderKyc = {
            kycDocumentLoading: false,
            loadSuccess: true
        };

        LoaderKyc.afterLoad = function (success, successFunction, errorFunction)//boolean
        {
            LoaderKyc.loadSuccess &= success;
            if (!LoaderKyc.kycDocumentsLoading) {
                if (LoaderKyc.loadSuccess) {
                    if (successFunction !== undefined)
                        successFunction();
                } else {
                    if (errorFunction !== undefined)
                        errorFunction(LoaderKyc.securityError);
                }
                LoaderKyc.loaded = true;
            }
        };

        LoaderKyc.load = function (successFunction, errorFunction) {
            if (LoaderKyc.loaded) {
                if (successFunction !== undefined)
                    successFunction();
                return;
            }

            // Load already in process
            if (LoaderKyc.kycDocumentsLoading)
                return;

            LoaderKyc.kycDocumentsLoading = true;
            KycDocumentSrv.query(
                function () {
                    LoaderKyc.kycDocumentsLoading = false;
                    LoaderKyc.afterLoad(true, successFunction, errorFunction);
                },
                function (data) {
                    if (data && data.status === 403)
                        LoaderKyc.securityError = true;
                    LoaderKyc.kycDocumentsLoading = false;
                    LoaderKyc.afterLoad(false, successFunction, errorFunction);
                }
            );
        };

        return LoaderKyc;
    }
]);



// WEBPACK FOOTER //
// ./js/services/models/LoaderKyc.js